<app-search-filter-value-list
  filterName="library"
  (visible)="visible.next($event)"
  [keyValues]="keyValues"></app-search-filter-value-list>
